import {PLACE_ORDER} from "./actionTypes";
import {PLACE_ORDER_URL} from "../../configs";
import {APPLY_COUPON} from "../coupon/actionTypes";

import Axios from "axios";
import {updateCart} from "../total/actions";

export const placeOrder = (
    user,
    order,
    coupon,
    location,
    order_comment,
    total,
    method,
    payment_token,
    delivery_type,
    partial_wallet,
    distance,
    pending_payment,
    tipAmount,
    cash_change_amount,
    props
) => (dispatch, getState) => {
    return Axios.post(PLACE_ORDER_URL, {
        token: user.data.auth_token,
        user: user,
        order: order,
        coupon: coupon,
        location: location,
        order_comment: order_comment,
        total: total,
        method: method,
        payment_token: payment_token,
        delivery_type: delivery_type,
        partial_wallet: partial_wallet,
        dis: distance,
        pending_payment: pending_payment,
        tipAmount: tipAmount,
        cash_change_amount: cash_change_amount,
        schedule_date:
            localStorage.getItem("orderDate") !== null ? JSON.parse(localStorage.getItem("orderDate")) : null,
        schedule_slot:
            localStorage.getItem("orderSlot") !== null ? JSON.parse(localStorage.getItem("orderSlot")) : null,
    })
        .then((response) => {
            const checkout = response.data;
            console.log("checkout: ", checkout);
            if (checkout.success) {
                console.log("going");
                dispatch({type: PLACE_ORDER, payload: checkout});

                const state = getState();
                const cartProducts = state.cart.products;

                // 	Clear localStorage items
                localStorage.removeItem("orderComment");
                localStorage.removeItem("orderSlot");
                localStorage.removeItem("orderDate");
                localStorage.removeItem("appliedCoupon");
                dispatch({type: APPLY_COUPON, payload: []});
                // Clear localStorage
                localStorage.removeItem("cart_tips")

                if (method === "COD") {
                    props.router?.navigate(`/running-order/${checkout?.data?.unique_order_id}`);
                    setTimeout(() => {
                        for (let i = cartProducts.length - 1; i >= 0; i--) {
                            cartProducts.splice(i, 1);
                        }
                        dispatch(updateCart(cartProducts));
                    }, 300);
                }
            } else {
                return checkout;
            }
        })
        .catch(function (error) {
            return error.response;
        });
};


// export const placeOrder = (
//     user,
//     order,
//     coupon,
//     location,
//     order_comment,
//     total,
//     method,
//     payment_token,
//     delivery_type,
//     partial_wallet,
//     distance,
//     pending_payment,
//     tipAmount,
//     cash_change_amount,
//     props
// ) => (dispatch, getState) => {
//
//     // ⛔ Skipping API call – return mock checkout object
//     return new Promise((resolve) => {
//
//         // console.log("deliverytYPE: ", method);
//         //
//         const mockResponse = {
//             "success": true,
//             "data": {
//                 "unique_order_id": "OD-12-15-AZ1I-MWLPE",
//                 "user_id": 34309,
//                 "zone_id": 1,
//                 "orderstatus_id": 1,
//                 "location": "{\"lat\":\"16.4472233\",\"lng\":\"80.592332\",\"address\":\"AIIMS Hospital Rd, Mangalagiri, Andhra Pradesh 522503, India\",\"house\":\"homw\",\"tag\":null}",
//                 "address": "homw, AIIMS Hospital Rd, Mangalagiri, Andhra Pradesh 522503, India",
//                 "restaurant_charge": null,
//                 "transaction_id": null,
//                 "sub_total": 160,
//                 "delivery_charge": 51,
//                 "actual_delivery_charge": 51,
//                 "service_fee_type": "percent",
//                 "service_fee": "0.00",
//                 "distance": 4.797531826323139,
//                 "tax_amount": 0,
//                 "payable": 211,
//                 "actual_total": 211,
//                 "actual_payment_mode": "COD",
//                 "total": 211,
//                 "order_comment": null,
//                 "payment_mode": "COD",
//                 "restaurant_id": 389,
//                 "tip_amount": null,
//                 "delivery_type": 1,
//                 "cash_change_amount": null,
//                 "delivery_pin": "29543",
//                 "updated_at": "2025-12-15T02:28:13.000000Z",
//                 "created_at": "2025-12-15T02:28:13.000000Z",
//                 "id": 254548
//             }
//         }
//
//         // ---- SAME SUCCESS FLOW ----
//         if (mockResponse.success) {
//             //
//             dispatch({type: PLACE_ORDER, payload: mockResponse});
//
//             const state = getState();
//             const cartProducts = state.cart.products;
//
//             // 	Clear localStorage items
//             localStorage.removeItem("orderComment");
//             localStorage.removeItem("orderSlot");
//             localStorage.removeItem("orderDate");
//             localStorage.removeItem("appliedCoupon");
//             dispatch({type: APPLY_COUPON, payload: []});
//             // Clear localStorage
//             localStorage.removeItem("cart_tips")
//
//             if (method === "COD") {
//                 props.router?.navigate(`/running-order/${mockResponse?.data?.unique_order_id}`);
//                 setTimeout(() => {
//                     for (let i = cartProducts.length - 1; i >= 0; i--) {
//                         cartProducts.splice(i, 1);
//                     }
//                     dispatch(updateCart(cartProducts));
//                 }, 300);
//             }
//             resolve(mockResponse);
//         } else {
//             resolve(mockResponse);
//         }
//     });
// };

export const resetCartAfterOrder = () => (dispatch, getState) => {
    const state = getState();
    const cartProducts = state.cart.products;

    for (let i = cartProducts.length - 1; i >= 0; i--) {
        cartProducts.splice(i, 1);
    }
    dispatch(updateCart(cartProducts));
    localStorage.removeItem("appliedCoupon");
    dispatch({type: APPLY_COUPON, payload: []});
}